<template>
  <div v-loading="loading">
    <pt-page-title :title="`${isEdit ? '编辑' :'新建'}直播`">
    </pt-page-title>
    <pt-live-list-form ref="form" class="pt-live-list-form__withData"  v-model="currentForm" @isUpload="isUpload"></pt-live-list-form>
    <div class="button-div">
      <el-button type="primary" @click="save">提交</el-button>
      <el-button type="primary" plain @click="cancel">取消</el-button>
    </div>
  </div>
</template>

<script>
import PtLiveListForm from './index'
export default {
  name: 'pt-live-list-form__withData',
  components: {
    'pt-live-list-form': PtLiveListForm
  },
  computed: {
    form () {
      return this.$refs.form
    },
    isEdit () {
      return this.$route.params.isEdit !== 'false'
    }
  },
  data () {
    return {
      loading: false,
      currentForm: {},
      isUploading: false
    }
  },
  methods: {
    save () {
      if (this.isUploading) {
        this.$message.error('请等待视频上传完毕再点击')
        return
      }
      this.$refs.form.validate().then(formValue => {
        this.loading = true
        this.isEdit ? this.edit() : this.create()
      })
    },
    isUpload (val) {
      this.isUploading = val
    },
    create () {
      this.$store.dispatch('createdLive', this.currentForm).then(data => {
        this.loading = false
        this.$message.success('创建成功！')
        this.cancel()
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    },
    edit () {
      this.$store.dispatch('updateLive', this.currentForm).then(data => {
        this.loading = false
        this.$message.success('保存成功！')
        this.cancel()
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    },
    cancel () {
      history.go(-1)
    },
    load () {
      this.loading = true
      this.$store.dispatch('getLiveDetail', this.$route.params.id).then(data => {
        this.currentForm = data.data
        this.loading = false
        console.log('====currentForm', this.currentForm)
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    }
  },
  created () {
    if (this.isEdit) {
      this.load()
    }
  }
}
</script>
